var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "work-permit dashboard" }, [
    _c("div", { staticClass: "tms-dashboard__panel-header flex-header" }, [
      _c("div", { staticClass: "wp-dashboard_non-btn-container" }, [
        _c("div", { staticClass: "tms-dashboard__panel-title-box" }, [
          _c("div", { staticClass: "tms-dashboard__panel-title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("currentWorkPermits")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tms-dashboard__panel-view-all" },
            [
              _c(
                "router-link",
                {
                  staticClass: "tms-dashboard__panel-view-all-today",
                  attrs: { to: "/work-permits?tag=today" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("viewAllTodayPermits")) +
                      " >\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/work-permits" } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("viewAll")) +
                    " >\n          "
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tms-dashboard__panel-toolbar" }, [
          _c("div", { staticClass: "handover-takeback__counter" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "handover-takeback__counter--duration" },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("showLabel")) + ":")]),
              _vm._v(" "),
              _c("HKLSelect", {
                attrs: {
                  options: _vm.wpTimeHklOptions,
                  placeholder: "",
                  showSearch: false,
                  value: _vm.selectedWpTimeValue,
                },
                on: { change: _vm.updateWPs },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wp-dashboard_btn-container" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--darkblue wp-dashboard__toolbar-reset-filter",
            attrs: { type: "button", role: "reset-button" },
            on: { click: _vm.resetWpDashboardFilters },
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("action.resetFilter")) + "\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn--orange",
            attrs: { disabled: _vm.filteredParsedWP.length === 0 },
            on: {
              click: function ($event) {
                return _vm.navToFirstWAPPRWp()
              },
            },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$i18n.t("action.startReview")) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "dashboard__table wp-dashboard-common-wrap wp-dashboard-common-table-theme",
      },
      [
        _c("CommonTable", {
          key: _vm.dashboardTableResetKey,
          ref: "wpDashboardCommonTable",
          attrs: {
            tableId: _vm.WP_DASHBOARD_TABLE_ID,
            renderHeaderList: _vm.wpDashboardRenderHeaderList,
            tableContentLists: _vm.filteredParsedWP,
            needSearch: true,
            needFilter: false,
            defaultOrderKey: "code",
            defaultOrder: true,
            yScrollAuto: true,
            minWidth1800px: false,
            getConditions: _vm.wpDashboardOnCommonTableConditions,
            enterEvent: _vm.wpDashboardFilterEnterNoop,
            interactionFunc: _vm.wpDashboardInteractionFunc,
            orderMethods: _vm.wpDashboardOrderMethods,
            getTableOrder: _vm.wpDashboardGetTableOrderNoop,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }